import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, INewsAttachment } from '../../model/news-attachment.model'

export const ACTION_TYPES = {
  SEARCH_NEWSATTACHMENTS: 'newsAttachment/SEARCH_NEWSATTACHMENTS',
  FETCH_NEWSATTACHMENT_LIST: 'newsAttachment/FETCH_NEWSATTACHMENT_LIST',
  FETCH_NEWSATTACHMENT: 'newsAttachment/FETCH_NEWSATTACHMENT',
  CREATE_NEWSATTACHMENT: 'newsAttachment/CREATE_NEWSATTACHMENT',
  UPDATE_NEWSATTACHMENT: 'newsAttachment/UPDATE_NEWSATTACHMENT',
  DELETE_NEWSATTACHMENT: 'newsAttachment/DELETE_NEWSATTACHMENT',
  SET_BLOB: 'newsAttachment/SET_BLOB',
  RESET: 'newsAttachment/RESET',
}

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<INewsAttachment>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
}

export type NewsAttachmentState = Readonly<typeof initialState>;

// Reducer

export default (state: NewsAttachmentState = initialState, action): NewsAttachmentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_NEWSATTACHMENTS):
    case REQUEST(ACTION_TYPES.FETCH_NEWSATTACHMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_NEWSATTACHMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      }
    case REQUEST(ACTION_TYPES.CREATE_NEWSATTACHMENT):
    case REQUEST(ACTION_TYPES.UPDATE_NEWSATTACHMENT):
    case REQUEST(ACTION_TYPES.DELETE_NEWSATTACHMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      }
    case FAILURE(ACTION_TYPES.SEARCH_NEWSATTACHMENTS):
    case FAILURE(ACTION_TYPES.FETCH_NEWSATTACHMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_NEWSATTACHMENT):
    case FAILURE(ACTION_TYPES.CREATE_NEWSATTACHMENT):
    case FAILURE(ACTION_TYPES.UPDATE_NEWSATTACHMENT):
    case FAILURE(ACTION_TYPES.DELETE_NEWSATTACHMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      }
    case SUCCESS(ACTION_TYPES.SEARCH_NEWSATTACHMENTS):
    case SUCCESS(ACTION_TYPES.FETCH_NEWSATTACHMENT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      }
    case SUCCESS(ACTION_TYPES.FETCH_NEWSATTACHMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.CREATE_NEWSATTACHMENT):
    case SUCCESS(ACTION_TYPES.UPDATE_NEWSATTACHMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.DELETE_NEWSATTACHMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      }
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      }
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
};

const apiUrl = 'api/news-attachments'
const apiExtendedUrl = 'api/extended/news-attachments'
const apiSearchUrl = 'api/_search/news-attachments'

// Actions

export const getSearchEntities: ICrudSearchAction<INewsAttachment> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_NEWSATTACHMENTS,
  payload: axios.get<INewsAttachment>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
})

export const getEntities: ICrudGetAllAction<INewsAttachment> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`
  return {
    type: ACTION_TYPES.FETCH_NEWSATTACHMENT_LIST,
    payload: axios.get<INewsAttachment>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  }
}

export const getEntity: ICrudGetAction<INewsAttachment> = id => {
  const requestUrl = `${apiUrl}/${id}`
  return {
    type: ACTION_TYPES.FETCH_NEWSATTACHMENT,
    payload: axios.get<INewsAttachment>(requestUrl),
  }
}

export const createEntity: ICrudPutAction<INewsAttachment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_NEWSATTACHMENT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  })
  dispatch(getEntities())
  return result
}

export const updateEntity: ICrudPutAction<INewsAttachment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_NEWSATTACHMENT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  })
  return result
}

export const deleteEntity: ICrudDeleteAction<INewsAttachment> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_NEWSATTACHMENT,
    payload: axios.delete(requestUrl),
  })
  dispatch(getEntities())
  return result
}

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
})

export const reset = () => ({
  type: ACTION_TYPES.RESET,
})

export const getEntitiesForNewsPost: ICrudGetAllAction<INewsAttachment> = (page, size, sort, newsPostId?) => {
  const requestUrl = `${apiExtendedUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`
  return {
    type: ACTION_TYPES.FETCH_NEWSATTACHMENT_LIST,
    payload: axios.get<INewsAttachment>(`${requestUrl}${sort ? '&' : '?'}newsPostId=${newsPostId}&cacheBuster=${new Date().getTime()}`),
  }
}

export const createEntityForNewsPost: ICrudPutAction<INewsAttachment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_NEWSATTACHMENT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  })
  return result
}

export const deleteEntityForNewsPost: ICrudDeleteAction<INewsAttachment> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_NEWSATTACHMENT,
    payload: axios.delete(requestUrl),
  })
  return result
}
